import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";

import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../Base/Services/ToastService";
import CardNotificaciones from "../../../Base/Components/Card/CardNotifcaciones";

import { descartarNotificacion, getNotificacionesByUser, leerNotificacion } from "../../../Base/API/IT/Accesos/AccesosRequests";


const HomeScreen = () => {
    const { userAuth } = useContext(AuthContext);
    const toast = useRef(null)
    const [notificaciones, setNotificaiones] = useState([]);
    const navigate = useNavigate();

    const ObtenerNotificaciones = async () => {
        const respuesta = await getNotificacionesByUser(userAuth?.IdUser)
        setNotificaiones(respuesta.filter(i => i?.Leida === false))
    }

    const abrirNavegacion = async(item) => {
        if(item?.URL){
            navigate(`${process.env.REACT_APP_ENV}${item?.URL}`, { replace: true,  state: { Referencia: item.Referencia || null } })
            await leerNotificacion(item?.IdNotificacion)
        }
    }

    const DescartarNotificacion = async (item) => {
        let IdNotificacion = item?.IdNotificacion
        const resp = await descartarNotificacion(IdNotificacion)      
        toastShow(toast, 'success', 'Descartada', item?.Referencia ? `Notificacion de ${item?.Referencia || ''} fue descartada correctamente.` : 'Notificación descartada correctamente.')  
        ObtenerNotificaciones()
    }

    useEffect(() => {
        setTitlePage('Home')
        ObtenerNotificaciones()
    }, [])

    return (
        <div style={{ height: '100%' }}>
            <Toast ref={toast}/>
            <div style={{bottom: 0, backgroundSize: 'cover', backgroundPosition: 'center', overflow: 'hiddden', height: '100%', width: '100%', backgroundImage: `url(${process.env.REACT_APP_FONDO_LOGO})` }} 
                className="contenedor-imagen animate__animated animate__fadeIn animate__faster ">

                <div className="homeTabView_Extenciones">
                </div>

                <div
                    style={{
                        minWidth: "18%",
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "100%",      
                        overflowY: "auto",    
                        overflowX: "hidden", 
                        padding: 10,
                    }}
                    className="contenidoCard"
                >
                    {notificaciones.map((item) => (
                        <div key={item.IdNotificacion} onClick={() => abrirNavegacion(item)} style={{alignItems:'center'}}>
                            <CardNotificaciones 
                                titulo={item?.Title}
                                contenido={
                                    <div className='pt-1 gap-2' style={{ height: '5vh', color: 'white' }}>
                                        <span>{item.body}</span><br />
                                        <span>Fecha: {new Date(item?.FechaNormal).toLocaleDateString()}</span>
                                    </div>
                                }
                                onClose={() =>DescartarNotificacion(item)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>

    )
}

export default HomeScreen;